export const lazyVideoObserver = () => {
  let videoObserver = null

  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((video) => {
        if (video.isIntersecting) {
          for (const source in video.target.children) {
            const videoSource = video.target.children[source]

            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
              videoSource.src = videoSource.dataset.src
            }
          }

          video.target.load()
          video.target.classList.remove('lazy-video')
          videoObserver.unobserve(video.target)
        }
      })
    })

    return videoObserver
  }
}
